import React, { useEffect, useState } from 'react'
import Sidebar from './Sidebar'
import { Box, Button } from '@mui/material'
import { Link, useNavigate } from 'react-router-dom'
import { DataGrid } from '@mui/x-data-grid';
import { useDispatch, useSelector } from 'react-redux';
import { deleteNotic, getNotic } from '../Store/ActionCreators/NotifactionActionCreator';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

export default function Notifaction() {
  const columns = [
    {
    field: "sn",
    headerName: "S.No",
    width: 60,
    sortable: false,
    filterable: false,
    renderCell: (params) => {
      return page * pageSize + params.api.getRowIndexRelativeToVisibleRows(params.id) + 1;
    }
  },
    {
      field: 'category',
      headerName: 'Category',
      width: 180,
      editable: true,
    },
    {
      field: 'titlename',
      headerName: 'Title of Notifaction',
      width: 250,
      editable: true,
    },
    {
      field: 'link',
      headerName: 'Link',
      width: 280,
      editable: true,
    },
    {
      field: 'createdAt',
      headerName: 'Create Date',
      width: 150,
      valueFormatter: (value) => {
        if (!value) return '';
        return new Date(value).toLocaleDateString('en-IN', {
          timeZone: 'Asia/Kolkata',
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
        });
      },
    },
    {
      field: 'status',
      headerName: 'Status',
      width: 110,
      editable: true,
    },
    {
        field: 'edit',
        headerName: 'Edit',
        sortable: false,
        renderCell: ({ row }) =>
          <Button onClick={() => {
            navigate("/updatenotifaction/" + row._id)
          }}>
           <EditIcon style={{color:"grayblue"}}/>
          </Button>,
      },
      {
        field: 'delete',
        headerName: 'Delete',
        width: 120,
        editable: true,
        renderCell: ({ row }) =>
          <Button onClick={() => {
            dispatch(deleteNotic({ _id: row._id }))
          }
          }>
            <DeleteIcon style={{color:"red"}}/>
          </Button>
      },
  ];
  const dispatch = useDispatch()
  const notifactionList = useSelector((state)=>state.NoticStateData) 
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const navigate = useNavigate()
  
  // const rows = notifactionList || [];

  useEffect(()=>{
    dispatch(getNotic())
  },[dispatch])

  return (
    <Box sx={{ display: 'flex' }}>
      <Sidebar />
      <Box className="boxStyle">
        <h4 className='bg-dark text-light p-1 text-center rounded mt-2 mb-3' style={{
              fontFamily: "'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif"
            }}>Notifaction <span style={{ float: 'right', fontWeight: "bold", marginRight: "10px" }}><Link to="/addnotifaction" style={{ textDecoration: "none", color: "#fff" }}>+</Link></span></h4>
            <h5 className='text-right'style={{textAlign: "right"}}>Total Category : {notifactionList.length}</h5>
                    <Box sx={{ height: 620, width: '100%' }}>
                      <DataGrid
                      sx={{
                border: "1px solid #636363ff",
                "& .MuiDataGrid-cell": {
                  border: "1px solid #dad8d8ff",
                },
                "& .MuiDataGrid-columnHeaders": {
                  borderBottom: "1px solid #636363ff",
                },
                textAlign:"center"
              }}
            
              rows={notifactionList}
              columns={columns}
              getRowId={(row) => row._id}
              pageSizeOptions={[5, 10, 20]}
              pagination
              paginationModel={{ page, pageSize }}
              onPaginationModelChange={(model) => {
                setPage(model.page);
                setPageSize(model.pageSize);
              }}
            />
            </Box>
      </Box>
    </Box>
  )
}
